<template>
    <!-- 修改保险方案 -->
    <el-drawer
        title="修改保险方案"
        :visible.sync="visible"
        :wrapperClosable="true"
        :append-to-body="true"
    >
        <el-form ref="formRef" :rules="rules" :model="form">
            <QS-column-box :column="1">
              <form-text-generator
                  v-for="(item, index) in config.insuranceTypeList"
                  :item="item"
                  :model="form"
                  :key="'insuranceTypeList' + index"
              ></form-text-generator>
            </QS-column-box>
            <div v-if="form.insuranceType.includes('commercialInsurance')">
                <form-text-generator
                    v-for="(item, index) in config.insuranceList"
                    :item="item"
                    :model="form"
                    :key="`insuranceList-${index}`"
                ></form-text-generator>
            </div>
        </el-form>

        <div class="bottom-btn">
            <el-divider></el-divider>
            <el-button @click="visible = false">取消</el-button>
            <el-button
                class="submit-btn"
                type="primary"
                @click="submit"
            >
                确定提交
            </el-button>
        </div>
    </el-drawer>
</template>

<script setup>
import { ref, watchEffect, toRefs } from 'vue'
import { omit } from 'lodash'
import { Message } from '@qs/ui'
import config from '../../add/config'
import { modifyInsuranceScheme } from '@/api/domain/purchase'

const props = defineProps(['orderId'])
const emit = defineEmits(['submitSucc'])

const { orderId } = toRefs(props)

const visible = ref(false)
const formRef = ref(null)

const rules = {
  insuranceType: [
    { required: true, message: '请选择保险类型', trigger: 'change' },
  ],
}

const form = ref({
  insuranceType: [],
  driverInsurance: 0,
  cdw: 0,
  tripleInsurance: 0,
  scratchInsurance: 0,
})

watchEffect(() => {
  if (!form.value.insuranceType.includes('commercialInsurance')) {
    form.value.driverInsurance = 0
    form.value.cdw = 0
    form.value.tripleInsurance = 0
    form.value.scratchInsurance = 0
  }
})

const open = () => {
  visible.value = true
}

const submit = () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      if (form.value.insuranceType.includes('commercialInsurance')) {
        const { driverInsurance, cdw, tripleInsurance, scratchInsurance } = form.value
        if ([driverInsurance, cdw, tripleInsurance, scratchInsurance].every((item) => item === 0)) {
          return Message.error('请至少投保一个商业险')
        }
      }

      const { code } = await modifyInsuranceScheme({
        orderId: orderId.value,
        ...omit(form.value, ['insuranceType']),
        compulsoryInsurance: form.value.insuranceType.includes('compulsoryInsurance') ? 0 : 1,
        commercialInsurance: form.value.insuranceType.includes('commercialInsurance') ? 0 : 1,
      })

      if (code === 1) {
        visible.value = false
        emit('submitSucc')
        Message.success('修改成功')
      }
    }
  })
}

defineExpose({
  open,
})
</script>

<style lang="scss" scope>
.bottom-btn {
  width: 100%;
  position: absolute;
  bottom: 10px;
  text-align: right;
  .submit-btn {
    margin-right: 10px;
  }
}

::v-deep .el-divider--horizontal {
  margin: 24px 0 10px 0;
}
</style>
